<template>
     <div class="main-content" id="panel">
      <!-- <Header /> -->
      <div class="header bg-primary pb-6">
        <div class="container-fluid">
          <div class="header-body">
            <div class="row align-items-center py-4">
              <div class="col-lg-6 col-7">
                <h2>Dashboard</h2>
              </div>
              <div class="text-right col-lg-6 col-5">
               <span class="time">Local: <i class="fas fa-clock"></i> <time v-text="timeDate"></time> </span>
               <span class="time">EST: <i class="fas fa-clock"></i> <time v-text="timeDateEST"></time> </span>
              </div>
            </div>
            <!-- Card stats -->
          </div>
        </div>
      </div>
      <div class="container-fluid mt--6 dashboard bidside" >
        <div class="row">
          <div class="col-xl-12">
            <div class="row">
              <div class="col-xl-3 col-md-6">
                <OutStandingBids />
              </div>
              <div class="col-xl-3 col-md-6 bidQty">
                <SetBidQuantity v-bind:bidSettings="bidSettings"/>
              </div>
              <div class="col-xl-3">
                <div class="row h-100">
                  <div class="col-xl-12 col-md-6 mb-3">
                    <SetMaxCapital  v-bind:bidSettings="bidSettings"/>
                  </div>
                  <div class="col-xl-12 col-md-6">
                     <SetBidValidity v-bind:bidSettings="bidSettings" />                   
                  </div>
                </div>
              </div>
              <div class="col-xl-3">
                <SetAccount v-bind:bidSettings="bidSettings" />                   
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-xl-3 col-md-6">
                <SpRatingGraphWidget />
              </div>
              <div class="col-xl-3 col-md-6 bidQty">
                <MoodysRatingGraphWidget />
              </div>
              <div class="col-xl-3 col-md-6">
                <CapitalRisk />
              </div>
              <div class="col-xl-3 col-md-6">
                <BlockedCusips />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-3 col-md-6">
            <Roles />
          </div>
          <div class="col-xl-3 col-md-6">
            <Users />
          </div>
        </div>
        <!-- <Footer /> -->
      </div>
    </div>
</template>
<script>
// import Header from "../../../common/Header";
// import Footer from "../../../common/Footer";
import OutStandingBids from "./OutStandingBidsWidget";
import SetBidQuantity from "./SetBidQuantityWidget";
import CapitalRisk from "./CapitalRiskWidget";
import MoodysRatingGraphWidget from "./MoodysRatingGraphWidget";
import SpRatingGraphWidget from "./SpRatingGraphWidget";
import SetMaxCapital from "./SetMaxCapitalWidget";
import SetBidValidity from "./SetBidValidityWidget";
import BlockedCusips from "./BlockedCusipsWidget";
import SetAccount from "./SetAccountWidget";
import Roles from "./RolesWidget";
import Users from "./UsersWidget";
import authService from "@/authService";
// //import axios from "axios";
import config from "@/config";
// import moment from 'moment'
// import moment_timezone from 'moment-timezone'

export default {
  name: "admin-dashboard",
   components: {
    // Header,
    // Footer,
    OutStandingBids,
    SetBidQuantity,
    CapitalRisk,
    MoodysRatingGraphWidget,
    SetMaxCapital,
    SetBidValidity,
    SpRatingGraphWidget,
    BlockedCusips,
    SetAccount,
    Roles,
    Users
  },
  data() {
    return {
      accessToken : null,
      bidSettings : {},
      timeDate : "",
      timeDateEST : ""
    };
  },
  methods: {
      getBidSettings(){
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide + "/organization/bid-settings?type=BID",
          auth
        )
        .then(response => {
          console.log(response);
          this.bidSettings = response.data;
        })
        .catch(e => {
          console.log(e);

        });
    },
    
  },
  created() {
    setInterval(() => {
      this.timeDate =  this.moment().format('LT') + " | " + this.moment().format('dddd') + ", " + this.moment().format("DD MMM YYYY");  
      this.timeDateEST =  this.moment_timezone().tz('America/New_York').format('LT') + " | " + this.moment_timezone().tz('America/New_York').format('dddd') + ", " + this.moment_timezone().tz('America/New_York').format("DD MMM YYYY");  
    }, 1000)
  },
  mounted() {
     this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        this.getBidSettings();
      }
    }); 
  }
};
</script>